<template>
  <div>
    <div v-if="showHeading">
    <el-row align="bottom">
       <el-col :span="16">
          <h1>{{localData.siteName}}</h1><span>&nbsp;{{localData.siteId}}</span>
       </el-col>

       <el-col align="right" :span="6">
         <i class="text-muted"><strong>{{localData.status}}</strong>{{localData.coverage ? ' | ' + localData.coverage : ''}}</i>
       </el-col>

    </el-row>

    <el-row>
      <span v-if="localData.structure.name || localData.structure.height">
        Structure: <strong v-if="localData.structure.name">{{localData.structure.name}}</strong>
        <span v-if="localData.structure.height">&nbsp;|&nbsp;<strong>{{localData.structure.height}}</strong>m.</span>
      </span>
    </el-row>

    <el-row>
        <span v-if="localData.latitude || localData.longitude">lat: <strong>{{localData.latitude}}</strong> / lng: <strong>{{localData.longitude}}</strong></span>
        <span v-if="localData.dimensions">&nbsp;| Stie dimensions: <strong>{{localData.dimensions}}</strong></span>
        <br />
      <br />
    </el-row>

    <el-row align="middle">
       <el-col :span="12">
          <i>{{localData.subdistrict}}</i> <i v-if="localData.district"><span v-if="localData.subdistrict">, </span>{{localData.district}}</i>
           <i v-if="localData.region"><span v-if="localData.district || localData.subdistrict">, </span>{{localData.region}}</i>
           <i v-if="localData.state"><span v-if="localData.district || localData.subdistrict || localData.region">, </span>{{localData.state}}</i>
           <i v-if="localData.country"><span v-if="localData.district || localData.subdistrict || localData.region || localData.state">, </span>{{localData.country}}</i>
       </el-col>
    </el-row>

    <el-row align="middle">
      <el-col :span="20" v-if="localData.address">
        <strong>{{localData.address}}</strong>
      </el-col>
      <el-col :span="20" v-else>
        <strong>No address found</strong>
      </el-col>

       <el-col :span="2">
          <small v-if="localData.zone">Local Council</small>
       </el-col>
       <el-col :span="2">
          <strong v-if="localData.zone">{{localData.zone}}</strong>
       </el-col>
    </el-row>
    </div>

    <div v-if="showHeading">

      <br />

      <el-tabs type="card">

        <el-tab-pane>
          <template #label><span><i class="fa fa-tools"></i> Equipment</span></template>
          <equip-table :siteId="localData.id" :siteData="siteData" />
        </el-tab-pane>


          <el-tab-pane lazy>
            <template #label><span><i class="fa fa-headset"></i> Maintenance</span></template>
            <site-maint :rowData="localData" />
          </el-tab-pane>

          <el-tab-pane lazy>
            <template #label><span><i class="fa fa-store-alt"></i> Tenancy</span></template>
            <site-tenancy :rowData="localData" :showAgreement="false" />
          </el-tab-pane>

          <el-tab-pane lazy>
            <template #label><span><i class="fa fa-paperclip"></i> Attachments</span></template>
            <site-attachments :row-data="localData" />
          </el-tab-pane>

          <el-tab-pane lazy>
            <template #label><span><i class="fa fa-map"></i> Map</span></template>
            <google-map :lat="localData.latitude"  :lng="localData.longitude"  />
          </el-tab-pane>

      </el-tabs>


      <el-row>
        <el-col :span="8">
          <small>Handover </small>
          <strong>{{formatDate(localData.handover)}}</strong>
           (<i>{{formatFriendlyDate(localData.handover)}}</i>)
        </el-col>

        <el-col align="middle" :span="8" v-if="localData.billing">
          <center>
          <small>Bill From </small>
          <strong>{{formatDate(localData.billing)}}</strong>

          <span>
           (<i>{{formatFriendlyDate(localData.billing)}}</i>)
          </span>
        </center>
        </el-col>
        <el-col v-else :span="8">&nbsp;</el-col>

        <el-col v-if="localData && localData.updated_at" align="right" :span="8">
            <small>Last Update </small>
            <strong>{{formatFriendlyDate (localData.updated_at)}}</strong><span v-if="localData.updated_by"> by {{localData.updated_by}}</span>
        </el-col>
      </el-row>
    </div>

    <div v-else>
      <equip-table
        :site-id="localData.siteName ? localData.id : localData.site_id"
        :owner-id="sharerId"
        :site-data="localData" />
    </div>
</div>
</template>

<script>

import DateMixins from '@/mixins/DateMixins'

import GoogleMap from '@/components/atoms/GoogleMap'

import EquipTable from '@/components/assets/EquipTable'

import SiteAttachments from '@/components/sites/SiteAttachments'
import SiteMaint from '@/components/sites/SiteMaint'
import SiteTenancy from '@/components/sites/SiteTenancy'

export default {

  mixins: [DateMixins],

  components: {
    EquipTable,
    GoogleMap,
    SiteAttachments,
    SiteMaint,
    SiteTenancy
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },

    sharerId: {
      type: Number,
      default: null
    },

    showHeading: {
      type: Boolean,
      default: true
    },

    readOnly: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      localData: this.rowData,
      siteData: this.siteData ? this.siteData : this.rowData
    }
  }
}
</script>
